import React, { PureComponent } from 'react';
import _ from 'lodash';
import styled from 'styled-components';

import { IntField, BooleanField, OptionData } from './Options';

import { Label, LabelName } from '../../ui';

interface EditConfigProps {
    options: OptionData[];
    values: Record<string, unknown>;
    onChange: (values: Record<string, unknown>) => void;
}

export default class EditConfig extends PureComponent<EditConfigProps> {
    render() {
        const { options, values, onChange, ...rest } = this.props;

        return (
            <div {...(rest as React.HTMLAttributes<HTMLDivElement>)}>
                {options.map((optData, index) => {
                    const { key, type } = optData;
                    const FieldKlass = type === 'boolean' ? BooleanField :
                        type === 'int' ? IntField :
                        null;

                    return (
                        <Label table key={`${index}-${key}`}>
                            <LabelName size={7} table>{key}:</LabelName>
                            {FieldKlass &&
                                <FieldKlass
                                    defaultValue={key ? values[key] : undefined}
                                    onChange={val =>
                                        onChange({
                                            ...values,
                                            ...(key ? { [key]: val } : null),
                                        })
                                    }
                                    data={optData}
                                />
                            }
                        </Label>
                    );
                })}
            </div>
        );
    }
}

const EditConfigWrapper = styled.div`
    border: 1px solid #ccc;
    background: wheat;
    margin-top: 1rem;
    padding: 1rem;
    max-width: 30rem;
`;

interface EditConfigDialogProps extends Omit<EditConfigProps, 'options'> {
    options: OptionData[];
}

export const EditConfigDialog = ({ options, ...rest }: EditConfigDialogProps) =>
    !_.size(options) ? null :
    <EditConfigWrapper>
        <h2 style={{ marginTop: 0 }}>Change Run Options</h2>
        <EditConfig options={options} {...rest} />
    </EditConfigWrapper>;
